import { render, staticRenderFns } from "./CustomRuleModal.vue?vue&type=template&id=3c724a9a&scoped=true&"
import script from "./CustomRuleModal.vue?vue&type=script&lang=js&"
export * from "./CustomRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomRuleModal.vue?vue&type=style&index=0&id=3c724a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c724a9a",
  null
  
)

export default component.exports